<template>
  <div class="expert_container">
    <!-- <topParts></topParts>
    <bottomParts></bottomParts> -->
    <div class=" part part1 part11">
      <div class="absolute number part1_txt1">419</div>
      <div class="absolute number part1_txt2">92</div>
      <div class="absolute number part1_txt3">412</div>
      <div class="absolute part1_txt4 ranking_num">超过同行业 <span class="rankNum">96.89</span> %同类企业</div>
    </div>
    <div class=" part part1 part12">
      <div class="absolute part1_txt4">55</div>
      <div class="absolute part1_txt5 type_">物料封闭运输</div>
      <div class="absolute part1_txt6 type_">生产工艺过程</div>
      <div class="absolute part1_txt7 type_">物料密闭储存和运输</div>
      <div class="absolute part1_txt8 type_">物料封闭储存</div>
      <div class="absolute part1_txt9 ranking_num">排放源清单关联率超过同行业 <span class="rankNum">65.35</span> %同类企业</div>
    </div>
    <div class="part part2">
      <div class="absolute number1 ">6158</div>
      <div class="absolute number2 ">4618</div>
      <div class="absolute part2_txt1 ">500</div>
      <div class="absolute part2_txt2 ">250</div>
      <div class="absolute part2_txt3 ">0</div>
      <div class="absolute part2_txt4 ranking_num">超过同行业 <span class="rankNum">92.34</span> %同类企业</div>
      <div class="absolute part2_txt5">每日闭环管理</div>
      <div class="absolute part2_txt6">闭环管理处理</div>
    </div>
    <div class="part part3">
      <div class="absolute part3_txt1 ranking_num">超过同行业 <span class="rankNum">87.63</span> %同类企业</div>
    </div>
    <div class="part part4">
      <div class="absolute part4_txt1">微站</div>
      <div class="absolute part4_txt2">TSP</div>
      <div class="absolute part4_txt3">CEMS</div>
      <div class="absolute part4_txt4">VDM</div>
      <div class="absolute part4_txt5">超标</div>
      <div class="absolute part4_txt6">超低</div>
      <div class="absolute part4_txt7">离线</div>
      <div class="absolute part4_txt8">同步率</div>
      <div class="absolute part4_txt9 ranking_num2">超过同行业 <span class="rankNum">97.52</span> %水平</div>
      <div class="absolute part4_txt10">385</div>
      <div class="absolute part4_txt11">294</div>
      <div class="absolute part4_txt12">213</div>
      <div class="absolute part4_txt13">197</div>
    </div>
    <div class="part part5">
      <div class="absolute part5_txt2 number">炼钢</div>
      <div class="absolute part5_txt3 number">烧结</div>
      <div class="absolute part5_txt4 number">球团</div>
      <div class="absolute part5_txt5 number">炼铁</div>
      <div class="absolute part5_txt6 number">轧钢</div>
      <div class="absolute part5_txt7 ranking_num2">超过同行业 <span class="rankNum"> </span>  同类企业</div>
      <!-- <div class="absolute part5_txt8">耗电</div> -->
    </div>
    <div class="part part6">
      <div class="absolute part6_txt1 number">60</div>
      <div class="absolute part6_txt2 number">0</div>
      <div class="absolute part6_txt3 ">96.44</div>
      <div class="absolute part6_txt4 ranking_num2">超过同行业 <span class="rankNum">96.21</span> %同类企业</div>
    </div>
    <div class="part part7">
      <div class="absolute part7_txt1">?</div>
      <div class="absolute part7_txt2 ranking_num2">超过同行业 <span class="rankNum"> </span>  同类企业</div>
    </div>
  </div>
</template>

<script>
import bottomParts from "@/modules/expertComponents/bottomParts/bottomParts.vue";
import topParts from "@/modules/expertComponents/topParts/topParts.vue";
export default {
  components: { topParts, bottomParts },
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  mounted() {},
  //方法集合
  methods: {
    reload() {
      this.refreshTag = false;
      this.$nextTick(function () {
        this.refreshTag = true;
        this.getVideoConf();
      });
    },
  },

  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped="scoped">
.expert_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: url("/static/images/common/expertBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .topParts {
    margin-top: 160px;
    height: 385px;
    width: 100%;
    padding: 0 55px;
    pointer-events: all;
  }
  .bottomParts {
    margin-top: 20px;
    height: 385px;
    width: 100%;
    padding: 0 55px;
    pointer-events: all;
  }
  .part {
    position: absolute;
    pointer-events: all;
  }
  .part1 {
    width: 581px;
    height: 385px;
    top: 160px;
  }
  .part2,
  .part3 {
    width: 1230px;
    height: 385px;
    top: 160px;
  }
  .part4,
  .part5,
  .part6,
  .part7 {
    width: 917.5px;
    height: 385px;
    top: 566px;
  }
  .part11 {
    left: 55px;
    .number {
      height: 60px;
      font-size: 52px;
      font-weight: 400;
      top: 170px;
      line-height: 60px;
    }
    .part1_txt1 {
      color: #f4c48f;
      left: 89px;
    }
    .part1_txt2 {
      color: #99f5ff;
      left: 270px;
    }
    .part1_txt3 {
      left: 433px;
      color: #30d594;
    }
    .part1_txt4 {
      // left: 313px;
    }
  }
  .part12 {
    left: 3174px;
    .part1_txt4 {
      font-family: "bigTitle" !important;
      font-size: 50px;
      font-weight: normal;
      color: #b1dbff;
      top: 190px;
      left: 385px;
    }
    .type_ {
      font-size: 10px;
      font-weight: 300;
      color: #f9f9f9;
    }
    .part1_txt5 {
      top: 331px;
      left: 149px;
    }
    .part1_txt6 {
      top: 227px;
      left: 60px;
      width: 44px;
    }
    .part1_txt7 {
      top: 134px;
      left: 135px;
    }
    .part1_txt8 {
      top: 227px;
      left: 270px;
      width: 44px;
    }
    .part1_txt9 {
    }
  }
  .part2 {
    left: 665px;
    .number1 {
      font-family: "bigTitle" !important;
      font-size: 46px;
      color: #f5a623;
      line-height: 60px;
      text-shadow: 8px 8px 8px rgba(245, 166, 35, 0.32);
      font-style: italic;
      top: 77px;
      left: 400px;
      font-weight: 600;
    }
    .number2 {
      font-family: "bigTitle" !important;
      font-size: 46px;
      color: #30d594;
      line-height: 60px;
      text-shadow: 8px 8px 8px rgba(35, 245, 158, 0.32);
      font-style: italic;
      top: 77px;
      left: 1000px;
      font-weight: 600;
    }
    .part2_txt1 {
      left: 50px;
      top: 190px;
      font-size: 14px;
      font-weight: 300;
      color: #9fbafd;
    }
    .part2_txt2 {
      left: 50px;
      top: 250px;
      font-size: 14px;
      font-weight: 300;
      color: #9fbafd;
    }
    .part2_txt3 {
      left: 60px;
      top: 310px;
      font-size: 14px;
      font-weight: 300;
      color: #9fbafd;
    }
    .part2_txt4 {
    }
    .part2_txt5 {
      font-family: "bigTitle" !important;
      font-size: 30px;
      color: #f5a623;
      line-height: 60px;
      text-shadow: 8px 8px 8px rgba(245, 166, 35, 0.32);
      font-style: italic;
      top: 77px;
      left: 70px;
      font-weight: 500;
    }
    .part2_txt6 {
      font-family: "bigTitle" !important;
      font-size: 30px;
      color: #30d594;
      line-height: 60px;
      text-shadow: 8px 8px 8px rgba(35, 245, 158, 0.32);
      font-style: italic;
      top: 77px;
      left: 670px;
      font-weight: 500;
    }
  }
  .part3 {
    left: 1915px;
    .part3_txt1 {
    }
  }
  .part4 {
    left: 55px;
    font-size: 20px;
    color: #ffffff;
    .part4_txt1 {
      top: 154px;
      left: 98px;
    }
    .part4_txt2 {
      top: 204px;
      left: 98px;
    }
    .part4_txt3 {
      top: 254px;
      left: 98px;
    }
    .part4_txt4 {
      top: 304px;
      left: 98px;
    }
    .part4_txt5 {
      top: 88px;
      left: 274px;
    }
    .part4_txt6 {
      top: 88px;
      left: 394px;
    }
    .part4_txt7 {
      top: 88px;
      left: 514px;
    }
    .part4_txt8 {
      top: 88px;
      left: 634px;
    }
    .part4_txt9 {
    }
    .part4_txt10 {
      left: 820px;
      top: 153px;
    }
    .part4_txt11 {
      left: 820px;
      top: 203px;
    }
    .part4_txt12 {
      left: 820px;
      top: 253px;
    }
    .part4_txt13 {
      left: 820px;
      top: 303px;
    }
  }
  .part5 {
    left: 995px;
    font-size: 15px;
    color: #ffffff;
    .part5_txt1 {
      top: 200px;
      left: 131px;
      font-size: 42px;
      color: #88f9fd;
    }
    .part5_txt2 {
      top: 316px;
      left: 438px;
    }
    .part5_txt3 {
      top: 316px;
      left: 523px;
    }
    .part5_txt4 {
      top: 316px;
      left: 605px;
    }
    .part5_txt5 {
      top: 316px;
      left: 689px;
    }
    .part5_txt6 {
      top: 316px;
      left: 773px;
    }
    .part5_txt7 {
    }
    .part5_txt8 {
      top: 100px;
      left: 360px;
      color: #9fbafd;
    }
    .part5_txt9 {
      top: 252px;
      left: 147px;
      color: #9fbafd;
    }
  }
  .part6 {
    left: 1939px;
    .part6_txt1 {
      top: 204px;
      left: 128px;
      font-size: 50px;
    }
    .part6_txt2 {
      top: 204px;
      left: 738px;
      font-size: 50px;
    }
    .part6_txt3 {
      top: 190px;
      left: 401px;
      font-size: 45px;
    }
    .part6_txt4 {
    }
  }
  .part7 {
    left: 2877px;
    .part7_txt1 {
      font-size: 70px;
      font-family: "bigTitle" !important;
      color: #ffffff;
      text-shadow: 8px 8px 8px rgba(255, 255, 255, 0.5);
      top: 184px;
      left: 114px;
    }
    .part7_txt2 {
    }
  }
}
</style>
<style scoped>
.ranking_num {
  width: 100%;
  font-size: 17px !important;
  color: #c0c4cc !important;
  top: 13px !important;
  text-align: end;
  right: 50px;
}
.ranking_num2 {
  width: 100%;
  font-size: 17px !important;
  color: #c0c4cc !important;
  top: 13px !important;
  text-align: end;
  right: 42px;
}
.rankNum {
  font-size: 30px;
  display: inline-block;
  margin: auto;
  vertical-align: sub;
  font-family: "number" !important;
  font-style: italic;
  text-shadow: 0.1rem 0rem 0.2rem #f5a623, -0.1rem 0rem 0.2rem #f5a623,
    0rem 0.1rem 0.2rem #f5a623, 0rem -0.1rem 0.2rem #f5a623;
}
</style>
